import { Input, Label, Checkbox } from '@/components/ui'
import { useValuationStore } from '@/store/valuationStore'

export function ContactStep() {
  const { formData, updateFormData } = useValuationStore()

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">I tuoi dati</h2>
        <p className="mt-1 text-gray-600">
          Inserisci i tuoi dati per ricevere la valutazione completa
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="firstName">Nome</Label>
          <Input
            id="firstName"
            value={formData.firstName || ''}
            onChange={(e) => updateFormData({ firstName: e.target.value })}
            placeholder="Mario"
          />
        </div>

        <div>
          <Label htmlFor="lastName">Cognome</Label>
          <Input
            id="lastName"
            value={formData.lastName || ''}
            onChange={(e) => updateFormData({ lastName: e.target.value })}
            placeholder="Rossi"
          />
        </div>

        <div>
          <Label htmlFor="email" required>
            Email
          </Label>
          <Input
            id="email"
            type="email"
            value={formData.email || ''}
            onChange={(e) => updateFormData({ email: e.target.value })}
            placeholder="mario.rossi@email.com"
          />
        </div>

        <div>
          <Label htmlFor="phone">Telefono</Label>
          <Input
            id="phone"
            type="tel"
            value={formData.phone || ''}
            onChange={(e) => updateFormData({ phone: e.target.value })}
            placeholder="+39 333 1234567"
          />
        </div>
      </div>

      <div className="space-y-4 pt-4 border-t border-gray-200">
        <div className="flex items-start gap-3">
          <Checkbox
            id="gdprConsent"
            checked={formData.gdprConsent || false}
            onChange={(e) => updateFormData({ gdprConsent: e.target.checked })}
          />
          <label htmlFor="gdprConsent" className="text-sm text-gray-600 cursor-pointer">
            <span className="text-red-500">*</span> Acconsento al trattamento dei miei dati personali
            ai sensi del Regolamento UE 2016/679 (GDPR) per le finalita indicate
            nell'informativa privacy.
          </label>
        </div>

        <div className="flex items-start gap-3">
          <Checkbox
            id="marketingConsent"
            checked={formData.marketingConsent || false}
            onChange={(e) => updateFormData({ marketingConsent: e.target.checked })}
          />
          <label htmlFor="marketingConsent" className="text-sm text-gray-600 cursor-pointer">
            Acconsento a ricevere comunicazioni commerciali e promozionali
            relative ai servizi immobiliari.
          </label>
        </div>
      </div>
    </div>
  )
}
